export default class TableProcessDeleteTableRowResultMixin {

//  abstract methods
//
// _addFilterUrlArgs(base_url);
// _resetViewAfterTableRowDeletion();
// _reinitDynamicBlock(html);
// _processWrongResult(result);


  _processDeleteTableRowResult(result) {

    this._resetViewAfterTableRowDeletion();

    if (!parseInt(result.status)) {
      this._processDeleteTableRowWrongResult(result);
      return;
    }

    this._processDeleteTableRowSuccessResult(result);
  }

  _processDeleteTableRowWrongResult(result) {

    if(result.hasOwnProperty('html')) {
      this._reinitDynamicBlock(result.html);
      return;
    }

    this._processWrongResult(result);
  }

  _processDeleteTableRowSuccessResult(result) {

    if(result.hasOwnProperty('html')) {
      this._reinitDynamicBlock(result.html);
    }
  }
}


/** WEBPACK FOOTER **
 ** ./src/common/table/process_delete_table_row_result_mixin.js
 **/